import script from "./MBreadcrumbV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./MBreadcrumbV2.vue?vue&type=script&setup=true&lang=ts"

import "./MBreadcrumbV2.vue?vue&type=style&index=0&id=4ba1bebe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba1bebe"]])

export default __exports__